// Generated by purs version 0.13.8
"use strict";
var Control_Category = require("../Control.Category/index.js");
var Control_Semigroupoid = require("../Control.Semigroupoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Formless_Class_Initial = require("../Formless.Class.Initial/index.js");
var Formless_Internal_Transform = require("../Formless.Internal.Transform/index.js");
var Record_Builder = require("../Record.Builder/index.js");
var Type_Data_Row = require("../Type.Data.Row/index.js");
var Type_Data_RowList = require("../Type.Data.RowList/index.js");
var MakeSProxies = function (makeSProxiesBuilder) {
    this.makeSProxiesBuilder = makeSProxiesBuilder;
};
var MakeInputFieldsFromRow = function (mkInputFieldsFromRowBuilder) {
    this.mkInputFieldsFromRowBuilder = mkInputFieldsFromRowBuilder;
};
var mkInputFieldsFromRowNil = new MakeInputFieldsFromRow(function (v) {
    return function (v1) {
        return Control_Category.identity(Record_Builder.categoryBuilder);
    };
});
var mkInputFieldsFromRowBuilder = function (dict) {
    return dict.mkInputFieldsFromRowBuilder;
};
var mkInputFieldsFromRowCons = function (dictIsSymbol) {
    return function (dictInitial) {
        return function (dictCons) {
            return function (dictMakeInputFieldsFromRow) {
                return function (dictRow1Cons) {
                    return new MakeInputFieldsFromRow(function (v) {
                        return function (r) {
                            var val = Formless_Class_Initial.initial(dictInitial);
                            var rest = mkInputFieldsFromRowBuilder(dictMakeInputFieldsFromRow)(Type_Data_RowList.RLProxy.value)(r);
                            var first = Record_Builder.insert()()(dictIsSymbol)(Data_Symbol.SProxy.value)(val);
                            return Control_Semigroupoid.compose(Record_Builder.semigroupoidBuilder)(first)(rest);
                        };
                    });
                };
            };
        };
    };
};
var mkInputFields = function (dictRowToList) {
    return function (dictNewtype) {
        return function (dictMakeInputFieldsFromRow) {
            return function (v) {
                var builder = mkInputFieldsFromRowBuilder(dictMakeInputFieldsFromRow)(Type_Data_RowList.RLProxy.value)(Type_Data_Row.RProxy.value);
                return Data_Newtype.wrap(dictNewtype)(Formless_Internal_Transform.fromScratch(builder));
            };
        };
    };
};
var makeSProxiesNil = new MakeSProxies(function (v) {
    return Control_Category.identity(Record_Builder.categoryBuilder);
});
var makeSProxiesBuilder = function (dict) {
    return dict.makeSProxiesBuilder;
};
var makeSProxiesCons = function (dictIsSymbol) {
    return function (dictRow1Cons) {
        return function (dictMakeSProxies) {
            return new MakeSProxies(function (v) {
                var rest = makeSProxiesBuilder(dictMakeSProxies)(Type_Data_RowList.RLProxy.value);
                var first = Record_Builder.insert()()(dictIsSymbol)(Data_Symbol.SProxy.value)(Data_Symbol.SProxy.value);
                return Control_Semigroupoid.compose(Record_Builder.semigroupoidBuilder)(first)(rest);
            });
        };
    };
};
var mkSProxies = function (dictRowToList) {
    return function (dictNewtype) {
        return function (dictMakeSProxies) {
            return function (v) {
                var builder = makeSProxiesBuilder(dictMakeSProxies)(Type_Data_RowList.RLProxy.value);
                return Formless_Internal_Transform.fromScratch(builder);
            };
        };
    };
};
module.exports = {
    makeSProxiesBuilder: makeSProxiesBuilder,
    mkInputFieldsFromRowBuilder: mkInputFieldsFromRowBuilder,
    mkInputFields: mkInputFields,
    MakeInputFieldsFromRow: MakeInputFieldsFromRow,
    mkSProxies: mkSProxies,
    MakeSProxies: MakeSProxies,
    mkInputFieldsFromRowNil: mkInputFieldsFromRowNil,
    mkInputFieldsFromRowCons: mkInputFieldsFromRowCons,
    makeSProxiesNil: makeSProxiesNil,
    makeSProxiesCons: makeSProxiesCons
};
